module.exports = __webpack_public_path__ + "media/vr.ce4363cd.mp3";